import React, { useState, useEffect } from "react";
import { Switch, Table, Tag, Pagination, Spin } from "antd";

import Sidebar from "../../../../components/AdminComponents/SideNav";
import {
  SecondaryNavTNCommunications,
  SettingsMenu,
} from "../../../../components/AdminComponents/MenuItems";
import SecondaryNav from "../../../../components/AdminComponents/SecondaryNav2";
import {
  capitalizeWords,
  remainingViewportHeight,
} from "../../../../components/icons/ApplicationColor";
import { CheckOutlined, CloseOutlined, DeleteTwoTone } from "@ant-design/icons";
import EditableImage from "../../../../components/icons/EditIcon";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import axiosInstance from "../../../../api/Axios";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { MAIN_LOGO_BIG } from "../../../../ImagesSrc";
const CustomNotificationsListing = () => {
  const history = useNavigate();
  const [data, setData] = useState();
  const [itemsLength, setItemsLength] = useState();
  const [loading, setLoading] = useState(false);
  const [filterData, setFilterData] = useState({
    pageSize: 15,
    currentPage: 1,
    active: true,
    url: `/customnotificationlist/?category=custom`,
    search: "",
    filters: "",
    filter_flag: false,
  });
  const { pageSize, currentPage, url, search, active, filters } = filterData;
  const LoadContacts = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 2) {
        passUrl += `&page=${currentPage}&page_size=${pageSize}&search=${search}${filters}&status=${
          active ? "True" : "False"
        }`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `&page=${currentPage}&page_size=${pageSize}${filters}&status=${
        active ? "True" : "False"
      }`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await axiosInstance.get(passUrl);
        setItemsLength(res.data.count);
        setData(res.data.results);
        setLoading(false);
      } catch (err) {
        // if (err.response && err.response.status === 404) {
        setLoading(false);
        // }
      }
    }
  };

  useEffect(() => {
    LoadContacts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);
  const renderStatus = (text, record) => {
    if (record.status) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckOutlined
              style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#ff4d4f",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CloseOutlined
              style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
            />
          </div>
        </div>
      );
    }
    // else {
    //   return text;
    // }
  };
  const [applications, setApplications] = useState([]);
  useEffect(() => {
    const LoadUser = async () => {
      try {
        const res = await axiosInstance.get("/traineryoneapplictaionlist/");
        //console.log(res.data);
        setApplications(res.data);
      } catch (err) {
        //console.log(err);
      }
    };
    LoadUser();
  }, []);
  const handleRowClick = (record) => {
    // if (env === "local" || env === "dev") {
    history(
      `/access-manager/notifications/custom-notifications/edit/${record}`
    );
    // }
  };
  const columns = [
    {
      title: capitalizeWords("category"),
      dataIndex: "sub_category",
      key: "sub_category",
      width: 250,
    },
    {
      title: capitalizeWords("priority"),
      dataIndex: "priority",
      key: "priority",
      width: 150,
      render: (priority) => {
        const color =
          priority === "High"
            ? "red"
            : priority === "Medium"
            ? "orange"
            : "green";
        return <Tag color={color}>{priority || "NA"}</Tag>;
      },
    },
    {
      title: capitalizeWords("application"),
      dataIndex: "application",
      key: "application",
      width: 200,
      render: (appId) => {
        const matchedApplication =
          appId === -1
            ? MAIN_LOGO_BIG
            : applications?.find((app) => app.id === appId)?.logo ||
              MAIN_LOGO_BIG;

        return matchedApplication ? (
          <img
            src={matchedApplication}
            alt="App Logo"
            className="app-logo"
            style={{ height: "20px" }}
          />
        ) : (
          ""
        );
      },
    },
    {
      title: capitalizeWords("title"),
      dataIndex: "notification_content",
      key: "notification_content",
      width: 250,
    },
    {
      title: capitalizeWords("start time"),
      dataIndex: "start_date",
      key: "start_date",
      width: 200,
      render: (startDate) => moment(startDate).format("MMM DD YYYY hh:mm A"),
    },
    {
      title: capitalizeWords("end time"),
      dataIndex: "end_date",
      key: "end_date",
      width: 200,
      render: (startDate) => moment(startDate).format("MMM DD YYYY hh:mm A"),
    },
    {
      title: capitalizeWords("status"),
      dataIndex: "status",
      key: "status",
      render: renderStatus,
      align: "center",
      width: 100,
    },
    {
      title: capitalizeWords("actions"),
      key: "actions",
      dataIndex: "actions",
      align: "center",
      width: 150,
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation(); // this will avoid onRow being called
            // go to placeUrl(routes.platformDetails, {})
          },
        };
      },
      render: (text, record) => {
        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <EditableImage
              handleRowClick={handleRowClick}
              recordId={record.id}
            />
            <DeleteTwoTone
              style={{
                cursor: "pointer",
                fontSize: "1.8rem",
                marginLeft: "0.9rem",
              }}
              title="delete"
              twoToneColor="#eb2f96"
            />
          </div>
        );
      },
    },
  ];
  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };
  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };
  const handleSwitchChange = (checked) => {
    setFilterData((prevData) => ({
      ...prevData,
      active: checked,
      currentPage: 1,
    }));
  };

  return (
    <Sidebar props={SettingsMenu}>
      <SecondaryNav menuItems={SecondaryNavTNCommunications} />
      <Spin spinning={loading}>
        <CommonTopDetails
          title={`${active ? "Active" : "Inactive"} Custom Notifications`}
          titleSuffix={`${itemsLength || 0} content(s)`}
          searchPlaceholder="Search by..."
          filterAction={false}
          searchAction={handleSearchChange}
          marginPass="12.5px"
          showAddButton={true}
          addButtonProps={{
            modalType: "Redirect",
            redirctlink: `/access-manager/notifications/custom-notifications/add`,
          }}
          customContent={
            <Switch
              style={{
                backgroundColor: active ? "#50C878" : "#FF0000",
                minWidth: "90px",
              }}
              checked={active}
              onChange={handleSwitchChange}
              checkedChildren="ACTIVE"
              unCheckedChildren="INACTIVE"
            />
          }
        />
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          size="small"
          bordered
          rowKey="id"
          scroll={{
            x: 1000,
            y: `${remainingViewportHeight(24)}px`,
          }}
          className="table-container"
          style={{ margin: "1rem" }}
          onRow={(record) => ({
            onClick: (event) => {
              if (
                event.target.closest(".ant-table-cell[data-index='actions']")
              ) {
                return;
              }

              handleRowClick(record.id);
            },
          })}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "1rem",
          }}
        >
          <Pagination
            size="small"
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            onChange={onPageChange}
            pageSizeOptions={["10", "15", "30", "50", "100"]}
            showQuickJumper
            current={currentPage}
            defaultPageSize={pageSize}
            total={itemsLength}
          />
        </div>
      </Spin>
    </Sidebar>
  );
};

export default CustomNotificationsListing;
